import React, { useState } from "react";
import styles from "./CSATPYQ.module.css";

const CSATPYQ = () => {
  const [searchTerm, setSearchTerm] = useState("");

  // PYQ data from 2011 to 2025 (descending order) - 15 rows
  // Simply copy and paste your Google Drive links in the fields below
  const pyqData = [
    // 2025
    {
      id: 1,
      year: 2025,
      paper1: {
        title: "UPSC CSAT Paper - 2025",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_CSAT_2025_ID", // Paste CSAT paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_CSAT_2025_ID/view" // Paste CSAT view link here
      }
    },
    // 2024
    {
      id: 2,
      year: 2024,
      paper1: {
        title: "UPSC CSAT Paper - 2024",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_CSAT_2024_ID", // Paste CSAT paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_CSAT_2024_ID/view" // Paste CSAT view link here
      }
    },
    // 2023
    {
      id: 3,
      year: 2023,
      paper1: {
        title: "UPSC CSAT Paper - 2023",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_CSAT_2023_ID", // Paste CSAT paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_CSAT_2023_ID/view" // Paste CSAT view link here
      }
    },
    // 2022
    {
      id: 4,
      year: 2022,
      paper1: {
        title: "UPSC CSAT Paper - 2022",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_CSAT_2022_ID", // Paste CSAT paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_CSAT_2022_ID/view" // Paste CSAT view link here
      }
    },
    // 2021
    {
      id: 5,
      year: 2021,
      paper1: {
        title: "UPSC CSAT Paper - 2021",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_CSAT_2021_ID", // Paste CSAT paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_CSAT_2021_ID/view" // Paste CSAT view link here
      }
    },
    // 2020
    {
      id: 6,
      year: 2020,
      paper1: {
        title: "UPSC CSAT Paper - 2020",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_CSAT_2020_ID", // Paste CSAT paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_CSAT_2020_ID/view" // Paste CSAT view link here
      }
    },
    // 2019
    {
      id: 7,
      year: 2019,
      paper1: {
        title: "UPSC CSAT Paper - 2019",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_CSAT_2019_ID", // Paste CSAT paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_CSAT_2019_ID/view" // Paste CSAT view link here
      }
    },
    // 2018
    {
      id: 8,
      year: 2018,
      paper1: {
        title: "UPSC CSAT Paper - 2018",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_CSAT_2018_ID", // Paste CSAT paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_CSAT_2018_ID/view" // Paste CSAT view link here
      }
    },
    // 2017
    {
      id: 9,
      year: 2017,
      paper1: {
        title: "UPSC CSAT Paper - 2017",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_CSAT_2017_ID", // Paste CSAT paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_CSAT_2017_ID/view" // Paste CSAT view link here
      }
    },
    // 2016
    {
      id: 10,
      year: 2016,
      paper1: {
        title: "UPSC CSAT Paper - 2016",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_CSAT_2016_ID", // Paste CSAT paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_CSAT_2016_ID/view" // Paste CSAT view link here
      }
    },
    // 2015
    {
      id: 11,
      year: 2015,
      paper1: {
        title: "UPSC CSAT Paper - 2015",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_CSAT_2015_ID", // Paste CSAT paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_CSAT_2015_ID/view" // Paste CSAT view link here
      }
    },
    // 2014
    {
      id: 12,
      year: 2014,
      paper1: {
        title: "UPSC CSAT Paper - 2014",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_CSAT_2014_ID", // Paste CSAT paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_CSAT_2014_ID/view" // Paste CSAT view link here
      }
    },
    // 2013
    {
      id: 13,
      year: 2013,
      paper1: {
        title: "UPSC CSAT Paper - 2013",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_CSAT_2013_ID", // Paste CSAT paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_CSAT_2013_ID/view" // Paste CSAT view link here
      }
    },
    // 2012
    {
      id: 14,
      year: 2012,
      paper1: {
        title: "UPSC CSAT Paper - 2012",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_CSAT_2012_ID", // Paste CSAT paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_CSAT_2012_ID/view" // Paste CSAT view link here
      }
    },
    // 2011
    {
      id: 15,
      year: 2011,
      paper1: {
        title: "UPSC CSAT Paper - 2011",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_CSAT_2011_ID", // Paste CSAT paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_CSAT_2011_ID/view" // Paste CSAT view link here
      }
    }
  ];

  // Filter years based on search
  const filteredData = pyqData.filter(item => 
    item.year.toString().includes(searchTerm)
  );

  // Download handler
  const handleDownload = (link) => {
    window.open(link, "_blank");
  };

  // View handler
  const handleView = (link) => {
    window.open(link, "_blank");
  };

  return (
    <div className={styles.pyqPage}>
      <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
          <h1 className={styles.title}>
            UPSC CSAT <span className={styles.gradient}>PYQs</span>
          </h1>
          <p className={styles.subtitle}>
            2011 - 2025 • 15 Years • Paper I
          </p>
        </div>

        {/* Search Bar */}
        <div className={styles.searchSection}>
          <div className={styles.searchBox}>
            <i className="fas fa-search"></i>
            <input
              type="text"
              placeholder="Search by year (e.g., 2024)"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
            />
            {searchTerm && (
              <button 
                className={styles.clearBtn}
                onClick={() => setSearchTerm("")}
              >
                <i className="fas fa-times"></i>
              </button>
            )}
          </div>
        </div>

        {/* Results Count */}
        <div className={styles.resultsInfo}>
          <span>Showing {filteredData.length} of {pyqData.length} years</span>
          <span className={styles.orderInfo}>(2025 → 2011)</span>
        </div>

        {/* PYQ Table - One row per year */}
        <div className={styles.tableWrapper}>
          <table className={styles.pyqTable}>
            <thead>
              <tr>
                <th>Year</th>
                <th>UPSC CSAT Paper</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <tr key={item.id} className={styles.tableRow}>
                    {/* Year Column */}
                    <td className={styles.yearCell}>
                      <span className={styles.yearBadge}>{item.year}</span>
                    </td>
                    
                    {/* Paper Column */}
                    <td className={styles.paperCell}>
                      <div className={styles.paperContent}>
                        <span className={styles.paperTitle}>
                          <i className="fas fa-file-pdf"></i>
                          {item.paper1.title}
                        </span>
                      </div>
                    </td>
                    
                    {/* Download Column */}
                    <td className={styles.downloadCell}>
                      <div className={styles.buttonGroup}>
                        <button 
                          className={styles.viewBtn}
                          onClick={() => handleView(item.paper1.viewLink)}
                          title="View PDF"
                        >
                          <i className="fas fa-eye"></i>
                          View
                        </button>
                        <button 
                          className={styles.downloadBtn}
                          onClick={() => handleDownload(item.paper1.downloadLink)}
                          title="Download PDF"
                        >
                          <i className="fas fa-download"></i>
                          Download
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className={styles.noData}>
                    <div className={styles.noDataContent}>
                      <i className="fas fa-search"></i>
                      <p>No results found for "{searchTerm}"</p>
                      <button 
                        className={styles.resetBtn}
                        onClick={() => setSearchTerm("")}
                      >
                        Clear Search
                      </button>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* REMOVED: Download All Section */}
      </div>
    </div>
  );
};

export default CSATPYQ;